import Profile from ".";

export const profileRoutes = (data) => [
  {
    path: "/admin/profile",
    title: "profile",
    layout: "admin",
    routeType: "admin",
    component: Profile,
  },
];
